import React from 'react';
import Icon from '../../Icon';
import { useNavigate } from 'react-router-dom';
import { remove as removeAddress } from '../../../Actions/Address.action';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { getColor } from '../../../styling/mixins/colors';
import { fontFamilyBold, text } from '../../../styling/mixins/typography';
import Button from '../../Button';

const StyledAddressMobileItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.6rem;
  border: 1px solid ${getColor('grey', 300)};
  border-radius: 4px;
  margin-bottom: 1.6rem;

  .span-wrapper {
    display: flex;
    flex-direction: column;
  }
  .item-span {
    ${text('medium')}
    text-transform: capitalize;
  }

  .primary-item-span {
    ${text('large')}
    ${fontFamilyBold}
  }

  .btn-wrapper {
    display: flex;
    gap: 0.8rem;

    #edit {
      border-color: ${getColor('primary')};
    }

    #delete {
      border-color: ${getColor('alert')};
      color: ${getColor('alert')};
    }
  }
`;

const AddressListItemMobile = ({ address }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <StyledAddressMobileItem>
      <div className="span-wrapper">
        <p className="item-span primary-item-span">{address.address}</p>
        <p className="item-span">
          {address.zipCode} {address.city}
        </p>
        <p className="item-span">{address.country}</p>
      </div>
      <div className="btn-wrapper">
        <Button
          id="edit"
          btnType="clear"
          btnSize="small"
          onClick={() => navigate(`edit/${address.systemId}`)}
        >
          <Icon
            name="edit"
            className="color-primary"
            style={{
              width: '16px',
              height: '16px',
            }}
          />
        </Button>
        <Button
          id="delete"
          btnType="clear"
          btnSize="small"
          onClick={() => {
            dispatch(removeAddress(address.systemId));
          }}
        >
          <Icon
            name="delete"
            className="color-alert"
            style={{
              width: '16px',
              height: '16px',
            }}
          />
        </Button>
      </div>
    </StyledAddressMobileItem>
  );
};
export default AddressListItemMobile;
